import React from "react";
import { Helmet } from "react-helmet-async";

export default function InsuranceOffers() {
  return (
    <>
      <Helmet>
        <title>Bike Insurance Offers India 2026 | Compare & Save | MotoHub India</title>

        <meta
          name="description"
          content="Compare best bike insurance offers in India from Acko, Digit, HDFC Ergo and more. Get lowest premium, fast claims and zero commission plans on MotoHub India."
        />

        <meta
          name="keywords"
          content="bike insurance India, two wheeler insurance offers, best bike insurance plans India, cheap motorcycle insurance India, compare bike insurance India, acko digit hdfc ergo insurance"
        />

        <link rel="canonical" href="https://motohubindia.com/insurance-offers" />

        {/* Open Graph */}
        <meta property="og:title" content="Best Bike Insurance Offers in India | MotoHub India" />
        <meta property="og:description" content="Compare top bike insurance plans, save money and get instant quotes online." />
        <meta property="og:image" content="https://motohubindia.com/logo.png" />
        <meta property="og:url" content="https://motohubindia.com/insurance-offers" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Bike Insurance Deals India" />
        <meta name="twitter:description" content="Find cheapest and best bike insurance plans in India." />
        <meta name="twitter:image" content="https://motohubindia.com/logo.png" />

        {/* SEO */}
        <meta name="robots" content="index, follow" />

        {/* JSON-LD (BIG SEO BOOST) */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: "Bike Insurance Offers India",
            description: "Compare bike insurance plans from top providers in India.",
            brand: {
              "@type": "Brand",
              name: "MotoHub India",
            },
            offers: {
              "@type": "AggregateOffer",
              lowPrice: "499",
              highPrice: "2000",
              priceCurrency: "INR",
            },
          })}
        </script>
      </Helmet>

      <div style={{ padding: "30px" }}>
        <h1 style={title}>🛡️ Bike Insurance Offers</h1>

        {/* SEO CONTENT (VERY IMPORTANT FOR RANKING) */}
        <p style={subtitle}>
          Compare the best bike insurance plans in India from trusted providers like Acko, Digit,
          HDFC Ergo, and PolicyBazaar. Find affordable premiums, zero commission policies, and fast
          claim services tailored for Indian riders.
        </p>

        <div style={grid}>
          <InsuranceCard
            name="Acko Insurance"
            feature="Zero Commission, Fast Claim"
            price="Starts ₹499"
            link="#"
          />
          <InsuranceCard
            name="PolicyBazaar"
            feature="Compare 20+ insurers"
            price="Best Deals"
            link="#"
          />
          <InsuranceCard
            name="Digit Insurance"
            feature="Super Fast Claim"
            price="₹599 onwards"
            link="#"
          />
          <InsuranceCard
            name="HDFC Ergo"
            feature="Trusted Brand"
            price="₹650 onwards"
            link="#"
          />
        </div>
      </div>
    </>
  );
}

function InsuranceCard({ name, feature, price, link }) {
  return (
    <div style={card}>
      <h3>{name}</h3>
      <p>{feature}</p>
      <p>{price}</p>

      <button style={btn} onClick={() => window.open(link)}>
        Get Quote
      </button>
    </div>
  );
}

/* styles */
const title = { fontSize: "28px", marginBottom: "10px" };
const subtitle = { color: "#aaa", marginBottom: "20px", lineHeight: "1.6" };

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
  gap: "20px",
};

const card = {
  background: "#111",
  padding: "20px",
  borderRadius: "12px",
  border: "1px solid #222",
};

const btn = {
  marginTop: "10px",
  padding: "10px",
  width: "100%",
  background: "#ff4d00",
  border: "none",
  borderRadius: "8px",
  color: "#fff",
  cursor: "pointer",
};